<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.EnvConditionInfos.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Menus.FillFields }}</span>

            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body">
                <div class="env-layout">
                    <div class="wizard-body">
                        <!-- Label above each control, a unit beside it; the checks are the ones the form had. -->
                        <div class="wizard-card">
                            <b-field class="stack-row"
                                     :type="{ 'is-danger': hasError_Ta || hasError_Ta2 }"
                                     :message="hasError_Ta ? $lang.Menus.EmptyWarning : (hasError_Ta2 ? $lang.EnvConditionInfos.TaRange : '')">
                                <template #label><span v-html="$lang.EnvConditionInfos.Ta"></span></template>
                                <div class="unit-control">
                                    <b-input class="unit-input" type="number" v-model="envTemperature" step="1" @input="getMaximumPanelTemperatures(); enableManuelSave();"></b-input>
                                    <span class="unit">°C</span>
                                </div>
                            </b-field>

                            <b-field class="stack-row" :type="{ 'is-danger': hasError_Tmax }" :message="emptyWarning_Tmax">
                                <template #label><span v-html="$lang.EnvConditionInfos.Tmax"></span></template>
                                <div class="unit-control">
                                    <b-select v-if="temperaturelist" v-model="temperature" class="unit-select" @input="enableManuelSave()">
                                        <option v-for="option in temperaturelist" :value="option" :key="option">
                                            {{ option }}
                                        </option>
                                    </b-select>
                                    <span class="unit">°C</span>
                                </div>
                            </b-field>

                            <b-field class="stack-row">
                                <template #label><span v-html="$lang.EnvConditionInfos.Humidity"></span></template>
                                <div class="unit-control">
                                    <b-input class="unit-input" v-model="humidity" disabled></b-input>
                                    <span class="unit-hint">{{ $lang.EnvConditionInfos.Fixed }}</span>
                                </div>
                            </b-field>

                            <b-field class="stack-row">
                                <template #label><span v-html="$lang.EnvConditionInfos.Altitude"></span></template>
                                <div class="unit-control">
                                    <b-select v-if="altitudelist" v-model="altitude" class="unit-select" @input="enableManuelSave()">
                                        <option v-for="option in altitudelist" :value="option" :key="option">
                                            {{ option }}
                                        </option>
                                    </b-select>
                                    <span class="unit">m</span>
                                </div>
                            </b-field>
                        </div>

                        <div class="info-card">
                            <span class="mdi mdi-information-outline" aria-hidden="true"></span>
                            <p>{{ $lang.EnvConditionInfos.Info }}</p>
                        </div>
                    </div>

                    <div class="figure-card">
                        <img v-if="!isLangEn" src="/img/Oda_TR.png" :alt="$lang.EnvConditionInfos.Title" />
                        <img v-else src="/img/Oda_EN.png" :alt="$lang.EnvConditionInfos.Title" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';

    export default {
        name: 'PanelInfos',
        components: {
            VerticalStepBar,
        },
        data() {
            return {
                isActive: true,
                isLangEn: false,
                isInfoOpened: false,
                envTemperature: 35,
                temperaturelist: [],
                temperature: 0,
                humidity: '50%',
                altitudelist: [],
                altitude: 0,
                canGoNextPage: false,
                hasError_Ta: false,
                hasError_Ta2: false,
                emptyWarning_Ta: '',
                hasError_Tmax: false,
                emptyWarning_Tmax: ''
            }
        },
        mounted() {
            if (this.$lang.Format.Lang == 'en-EN') {
                this.isLangEn = true;
            } else {
                this.isLangEn = false;
            }

            this.getMaximumPanelTemperatures();
            this.getAltitudes();

            this.temperature = this.$store.state.maxTemperature;
            if (this.$store.state.envTemperature != 0) {
                this.envTemperature = this.$store.state.envTemperature;
            }
            this.altitude = this.$store.state.altitude;
            this.$store.state.activeStep = 2;
            this.$store.state.isFooterFixed = true;
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/panelInfos');
            },
            submit() {
                this.controlInputs();

                if (this.canGoNextPage) {
                    this.setSavePayload();

                    var payload = { envTemperature: this.envTemperature, maxTemperature: this.temperature, humidity: this.humidity, altitude: this.altitude };
                    this.$store.commit('setEnvConditionDatas', payload);

                    this.$store.isPageOpenedFromStepBar = false;
                    this.$store.canCalculationOpen = true;

                    if (this.$store.state.calcIndex == 3) {
                        router.push('/calc_Summary');
                    } else {
                        router.push('/calculation');
                    }
                }
            },
            enableManuelSave() {
                this.$store.state.canManuelSave = true;
            },
            setSavePayload() {
                var payload = { envTemperature: this.envTemperature, maxTemperature: this.temperature, humidity: this.humidity, altitude: this.altitude };
                this.$store.commit('setEnvConditionDatas', payload);
            },
            controlInputs() {
                if (this.envTemperature == 0) {
                    this.hasError_Ta = true;
                    this.emptyWarning_Ta = this.$lang.Menus.EmptyWarning;
                } else if (this.envTemperature < 10 || this.envTemperature > 50) {
                    this.hasError_Ta2 = true;
                } else if (this.temperature == 0) {
                    this.hasError_Tmax = true;
                    this.emptyWarning_Tmax = this.$lang.Menus.EmptyWarning;
                } else {
                    this.canGoNextPage = true;
                }

                if (this.envTemperature != 0) {
                    this.hasError_Ta = false;
                    this.emptyWarning_Ta = "";
                }
                if (this.envTemperature >= 10 && this.envTemperature <= 50) {
                    this.hasError_Ta2 = false;
                }
                if (this.temperature != 0) {
                    this.hasError_Tmax = false;
                    this.emptyWarning_Tmax = "";
                }
            },
            getMaximumPanelTemperatures() {
                var tempEnvTemperature = this.envTemperature + '';
                tempEnvTemperature = tempEnvTemperature.replace(/[^0-9]/g, '');
                this.envTemperature = tempEnvTemperature;

                if (this.envTemperature < 10 || this.envTemperature > 50) {
                    this.hasError_Ta2 = true;
                } else {
                    this.hasError_Ta2 = false;
                }

                if (this.envTemperature == 0) {
                    this.hasError_Ta = true;
                } else {
                    this.hasError_Ta = false;
                }

                this.temperaturelist = [];
                api.panels.getMaximumPanelTemperatures(this.envTemperature).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.temperaturelist.push(e);
                        });
                    }
                });
            },
            getAltitudes() {
                this.altitudelist = [];
                api.panels.getAltitudes().then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.altitudelist.push(e);
                        });
                    }
                });
            },
            openInfo() {
                if (!this.isInfoOpened) {
                    this.isInfoOpened = true;
                } else {
                    this.isInfoOpened = false;
                }
            }
        },

    };
</script>
